const t = [
  { label: "不允許", value: "no" },
  { label: "允許", value: "yes" },
  { label: "只有缺貨時允許", value: "notify" }
], u = [
  {
    label: "有庫存",
    value: "instock",
    color: "blue"
  },
  {
    label: "缺貨",
    value: "outofstock",
    color: "magenta"
  },
  {
    label: "預定",
    value: "onbackorder",
    color: "cyan"
  }
], c = [
  {
    label: "商品發佈日期",
    value: "date_created"
  },
  {
    label: "商品修改日期",
    value: "date_modified"
  },
  {
    label: "特價開始日期",
    value: "date_on_sale_from"
  },
  {
    label: "特價結束日期",
    value: "date_on_sale_to"
  }
], i = [
  {
    value: "simple",
    label: "簡單商品",
    color: "processing"
    // 藍色
  },
  {
    value: "grouped",
    label: "組合商品",
    color: "orange"
    // 綠色
  },
  {
    value: "external",
    label: "外部商品",
    color: "lime"
    // 橘色
  },
  {
    value: "variable",
    label: "可變商品",
    color: "magenta"
    // 紅色
  },
  {
    value: "variation",
    label: "商品變體",
    color: "magenta"
    // 紅色
  },
  {
    value: "subscription",
    label: "簡易訂閱",
    color: "cyan"
    // 紫色
  },
  {
    value: "variable-subscription",
    label: "可變訂閱",
    color: "purple"
    // 青色
  },
  {
    value: "subscription_variation",
    label: "訂閱變體",
    color: "purple"
  }
], n = [
  {
    value: "hidden",
    label: "隱藏",
    color: "red"
  },
  {
    value: "visible",
    label: "出現在商店與搜尋結果",
    color: "green"
  },
  {
    value: "search",
    label: "只出現在搜尋結果",
    color: "blue"
  },
  {
    value: "catalog",
    label: "只出現在商店",
    color: "orange"
  }
], o = (l = "商品") => ({
  s: "關鍵字",
  sku: "貨號(sku)",
  type: "商品類型",
  product_category_id: `${l}分類`,
  product_tag_id: `${l}標籤`,
  product_brand_id: "品牌",
  status: `${l}狀態`,
  featured: "精選商品",
  downloadable: "可下載",
  virtual: "虛擬商品",
  sold_individually: "單獨販售",
  backorders: "允許延期交貨",
  stock_status: "庫存狀態",
  date_created: `${l}發佈日期`,
  price_range: "價格範圍",
  author: "作者",
  include: "包含指定商品"
}), s = (l, e = "商品") => {
  var a;
  return ((a = o(e)) == null ? void 0 : a[l]) || l;
}, b = (l) => l == null ? void 0 : l.startsWith("variable"), d = (l) => r(l), r = (l) => !!(l != null && l.includes("variation")), v = (l) => !!(l != null && l.includes("subscription"));
export {
  t as BACKORDERS,
  n as PRODUCT_CATALOG_VISIBILITIES,
  c as PRODUCT_DATE_FIELDS,
  u as PRODUCT_STOCK_STATUS,
  i as PRODUCT_TYPES,
  d as getIsVariation,
  o as getProductFilterLabels,
  v as isSubscription,
  b as isVariable,
  r as isVariation,
  s as productKeyLabelMapper
};
